import axios from "axios";
import { baseUrl, portal } from "../App";

export const fetchProfileExtraData = async (token) => {
  const res = await axios.get(`${baseUrl}/profileSummeryOneApi/?portal=${portal}`, {
    headers: { Authorization: `Token ${token}` }
  });
  return res.data;
}